import { PropTypes } from "base/react-libs";
import { useIdentity } from "base/identity-resolver";
import { useState, useEffect } from "react";
import { moveConstituentToJourney } from "apps/journeys/utils/api-requests/modal-actions";
import { fetchAllJourneysForAllJourneyGroups } from "apps/journeys/utils/api-requests/journey-index";
import MoveModal from "apps/journeys/components/modals/common/move-modal";
import { trackJourneysAction } from "apps/journeys/utils/helpers/mixpanel";

const AddToJourneyModal = ({ isOpen, onClose, contact, activeCadence }) => {
  const { user, org } = useIdentity();
  const [journeysList, setJourneysList] = useState([]);
  const [activeJourney, setActiveJourney] = useState();

  useEffect(() => {
    if (activeCadence && activeCadence.journey_name !== null) {
      if ("journey_name" in activeCadence) {
        activeCadence.name = activeCadence.journey_name;
        delete activeCadence.journey_name;
      }
      setActiveJourney(activeCadence);
    }
  }, [contact, activeCadence]);

  useEffect(() => {
    const getAndSetJourneys = async () => {
      const journeysListResponse = await fetchAllJourneysForAllJourneyGroups();
      setJourneysList(journeysListResponse.map((j) => ({ label: j.name, value: j.id })));
    };
    getAndSetJourneys();
  }, [user.id]);

  const handleSubmit = async (selectedNewJourney) => {
    await moveConstituentToJourney(
      null,
      contact.id,
      user.id,
      org.id,
      selectedNewJourney.value,
      selectedNewJourney.label
    );
    trackJourneysAction("add_cadence_from_profile");
    onClose();
  };

  const mapContactObjectToGraphqlShape = (contact) => {
    // changes the shape of the contact object into the graphql payload that the contact card expects
    const { addresses, name, id, properties, profile_image } = contact;
    return {
      addresses,
      contact_attributes: {
        name_full: name,
        year: properties && properties.year && properties.year.value,
      },
      id,
      profile_image: profile_image && profile_image.url,
      constituencies: [],
    };
  };

  return (
    <MoveModal
      title="Add To Cadence"
      isOpen={isOpen}
      onClose={onClose}
      handleSubmit={handleSubmit}
      contact={mapContactObjectToGraphqlShape(contact)}
      options={journeysList}
      current={activeJourney}
    />
  );
};

AddToJourneyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  contact: PropTypes.object,
  activeCadence: PropTypes.object,
};
export default AddToJourneyModal;
